<template>
  <div>
    <Header />

    <header class="header5">
      <div class="container">
        <div class="header5-cont">
          <div class="t-wrap">
            <div class="title-row">
              <p>{{ $tc('contact_page.contact_page_p') }} <a href="#" class="bold-a">support@giveandget.io</a></p>
            </div>

            <div class="form-card-div2">
              <h1>{{ $tc('contact_page.contact_c_form_h1') }}</h1>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </header>

    <section class="white-part" />

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import ContactForm from '@/components/ContactForm'

export default {
  name: 'Contact',

  components: {
    Header,
    Footer,
    ContactForm
  },

  created () {
    document.title = `Contacto - ${process.env.VUE_APP_TITLE}`
  }
}
</script>
